import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentDashboardRange: null,
};

export const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setCurrentDashboardRange: (state, action) => {
      state.currentDashboardRange = action.payload;
    },
  },
});

export const { setCurrentDashboardRange } = dashboardSlice.actions;

export default dashboardSlice.reducer;
